export default {
  personUploads: "person-uploads",
};
